import styled, { css } from 'styled-components';
import ErrorMessage from '../error-message/ErrorMessage';
import { EyeCrossedIcon } from '../assets';
import Typography from '../typography/Typography';
export const INPUT_SIZE = {
    md: css `
    height: 5.4rem;
    border-radius: ${({ theme }) => theme.borderRadius.high};
  `,
    lg: css `
    height: 6.2rem;
    border-radius: ${({ theme }) => theme.borderRadius.mediumHigh};
  `,
};
export const CustomInput = styled.input `
  background: none;
  font-size: 1.6rem;
  line-height: 2.4rem;
  width: 100%;
  padding: 0;
  border: none;
  font-family: ${({ theme }) => theme.fonts.primary};
  color: ${({ theme }) => theme.colors.text.default};

  &:disabled {
    cursor: not-allowed;
    color: ${({ theme }) => theme.colors.text.disabled};
  }

  position: absolute;
  bottom: ${({ isFocused, hasPlaceholder }) => isFocused && hasPlaceholder ? '0' : '50%'};
  transform: translateY(
    ${({ isFocused, hasPlaceholder }) => isFocused && hasPlaceholder ? '0' : '50%'}
  );
`;
export const Wrapper = styled.div `
  width: 100%;
  ${({ size }) => (size ? INPUT_SIZE[size] : '')}
  display: flex;
  flex-direction: column;
  position: relative;
  transition: all 0.3s ease;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'text')};

  border-radius: ${({ theme, hasRightText }) => {
    const { mediumHigh } = theme.borderRadius;
    return hasRightText
        ? `${mediumHigh}rem;`
        : `${mediumHigh}rem 0 0 ${mediumHigh}rem;`;
}};
  background-color: ${({ theme, disabled }) => !disabled
    ? theme.colors.surface.interactiveDefault
    : theme.colors.surface.disabled};
  ${CustomInput} {
    &:autofill,
    &:autofill:hover,
    &:autofill:focus {
      box-shadow: ${({ theme }) => `0 0 0px 1000px ${theme.colors.surface.interactiveDefault} inset`};
      -webkit-text-fill-color: ${({ theme }) => theme.colors.text.default};
      transition: all 0.3s ease;
    }
  }

  border: 1px solid
    ${({ hasError, theme, disabled }) => {
    const { borders } = theme.colors;
    if (disabled)
        return borders.disabled;
    return hasError ? borders.critical : borders.default;
}};
  &:has(input:focus) {
    border: 1px solid ${({ theme }) => theme.colors.borders.pressed};
  }
  &:hover {
    background-color: ${({ theme, disabled }) => !disabled ? theme.colors.surface.hover : theme.colors.surface.disabled};
    border: 1px solid
      ${({ hasError, theme, disabled }) => {
    const { borders } = theme.colors;
    if (disabled)
        return borders.disabled;
    return hasError ? borders.critical : borders.hover;
}};
    ${({ hasBorder }) => (!hasBorder ? 'border: none' : '')}

    ${CustomInput} {
      &:autofill {
        box-shadow: ${({ theme }) => `0 0 0px 1000px ${theme.colors.surface.hover} inset`};
        transition: none;
      }
      &:autofill:hover,
      &:autofill:focus {
        box-shadow: ${({ theme }) => `0 0 0px 1000px ${theme.colors.surface.hover} inset`};
      }
    }
  }

  ${({ hasBorder }) => (!hasBorder ? 'border: none' : '')}

  margin-bottom: ${({ hasError }) => (hasError ? '1.2rem' : '0')};
`;
export const CustomErrorMessage = styled(ErrorMessage) `
  position: absolute;
  top: calc(100% + 0.4rem);
`;
export const Img = styled.img `
  height: 100%;
  max-width: 3.8rem;
  margin-right: 1.2rem;
`;
export const PlaceholderLabel = styled(Typography) `
  left: 0;
  top: ${({ isFocused }) => (isFocused ? '0' : '50%')};
  border: none;
  display: flex;
  position: absolute;
  align-items: center;
  pointer-events: none;

  color: ${({ isFocused, theme }) => isFocused ? theme.colors.text.secondary : theme.colors.text.default};

  font-size: ${({ isFocused }) => (!isFocused ? 1.6 : 1.2)}rem;
  line-height: ${({ isFocused }) => (!isFocused ? 2.4 : 1.8)}rem;

  transform: translateY(${({ isFocused }) => (isFocused ? '0' : '-50%')});

  transition-property: font-size, color, transform;
  transition: all 0.3s ease;
`;
export const PasswordIconButton = styled.button `
  top: 0;
  bottom: 0;
  border: none;
  right: 1.7rem;
  display: flex;
  outline: none;
  cursor: pointer;
  background: none;
  position: absolute;
  align-items: center;
  justify-content: center;
`;
export const InputContainer = styled.div `
  flex: 1;
  height: 100%;
  max-height: 4.2rem;
  display: flex;
  position: relative;
  align-items: flex-end;
`;
export const Label = styled.label `
  margin-bottom: 0.8rem;
  display: inline-block;
`;
export const Container = styled.div `
  flex: 1;
  display: flex;

  min-width: 14rem;

  padding: ${({ isPasswordInput, hasRightText }) => {
    if (isPasswordInput) {
        return '0.6rem 4.5rem 0.6rem 1.8rem;';
    }
    else if (hasRightText) {
        return '0 0.2rem 0 1.8rem;';
    }
    return '0.6rem 1.8rem;';
}}


  align-items: center;
`;
export const IconContainer = styled.button `
  border: none;
  right: 1.7rem;
  display: flex;
  outline: none;
  cursor: ${({ valid }) => (valid ? 'pointer' : 'not-allowed')};
  background: none;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 0.7rem;
  right: 0.8rem;
  bottom: 0.7rem;
  background-color: ${({ valid, theme }) => valid
    ? theme.colors.interactive.brandColor
    : theme.colors.interactive.brandColorDisabled};

  width: 100%;
  max-width: 10.2rem;
  border-radius: ${({ theme }) => theme.borderRadius.medium};
`;
export const SendCodeText = styled(Typography) `
  color: ${({ theme }) => theme.colors.text.interactive};
`;
export const CustomCrossedEyeIcon = styled(EyeCrossedIcon) `
  width: 1.8rem;
  height: 1.8rem;
`;
export const IconWrapper = styled.div `
  display: flex;
  margin-right: 1.2rem;
`;
// CODE INPUT styles
export const CodeInputWrapper = styled(Wrapper) `
  width: 4.5rem;
  height: 5.2rem;
  border-radius: ${({ theme }) => theme.borderRadius.mediumHigh};
  ${({ theme }) => theme.media.mobileM `
    width: 5rem;
  `};
`;
export const CustomCodeIput = styled(CustomInput) `
  padding: 0;
  width: 5rem;
  height: 5.2rem;
  text-align: center;
`;
export const RightTextWrapper = styled.div `
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 6rem;
  background-color: ${({ theme }) => theme.colors.surface.interactiveDefault};

  border-radius: ${({ theme }) => theme.borderRadius.mediumHigh};
  border-left: 0.1rem solid ${({ theme }) => theme.colors.borders.default};
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
`;
//# sourceMappingURL=styles.js.map